<div class="informacoes-cartao">
  <h2>{{nomeProduto}}</h2>
  <div class="info-container">
    <div class="info-column">
      <p>Número do cartão: <strong>{{numeroCartaoMascarado}}</strong></p>
      <p>Titular do cartão: <strong>{{customerName}}</strong></p>
    </div>

    <div *ngIf="debtValue" class="info-column">
      <p>Saldo devedor: <strong>{{debtValue | currency:'BRL'}}</strong></p>
    </div>
  </div>
</div>